import { createContext, type PropsWithChildren, useContext, useMemo } from 'react';

export type NavigationContextData = {
  currentPath: string;
};

export const NavigationContext = createContext<NavigationContextData | undefined>(undefined);
NavigationContext.displayName = 'NavigationContext';

export const NavigationProvider = ({ children, currentPath }: PropsWithChildren<NavigationContextData>) => {
  const value = useMemo(() => ({ currentPath }), [currentPath]);

  return <NavigationContext.Provider value={value}>{children}</NavigationContext.Provider>;
};

export const useNavigation = () => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error('useNavigation can only be used inside of NavigationProvider');
  }

  return context;
};
